import { render, staticRenderFns } from "./knowbefore-item.vue?vue&type=template&id=704e4b80&scoped=true&"
import script from "./knowbefore-item.vue?vue&type=script&lang=js&"
export * from "./knowbefore-item.vue?vue&type=script&lang=js&"
import style0 from "./knowbefore-item.vue?vue&type=style&index=0&id=704e4b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e4b80",
  null
  
)

export default component.exports